import React from "react";
import { useTranslation } from "react-i18next";
import Select from "react-select";

export default function ListSelect(props) {
  const { t } = useTranslation();
  return (
    // <div className={"form-group col-md-" + (props.colNumber || 4)}>
      <Select
        name={props.name}
        options={props.options || []}
        value={
            props.options && props.value
            ? props.options.find((option) => option === props.value)
            : ""
        }
        onChange={(option) => {
          if (option) {
            props.onUpdate(option);
          } else {
            props.onUpdate("");
          }
        }}
        isClearable={!props.required}
        style={{
          minHeight: "45px",
          lineHeight: "50px",
          color: "#7e7e7e",
          paddingLeft: " 15px",
        }}
        maxMenuHeight={250}
        placeholder={<span>{props.placeholder || t("formFields.selectPlaceHolder")}</span>}
      />
    // </div>
  );
}
